import { AssetClass } from '@/entities/assets'

import { TRANSACTION_TYPE } from '@/entities/transactions/utils/const'

import { WizardValues } from '../utils/types'
import { createHolding, ensureOwnerAccount, ensureTagIds } from '../utils/create'

/**
 * One liability, owed from the account the ownership step named.
 *
 * The type comes off the values rather than from a constant here: the flow
 * fixes it in its definition, and reading it back is what keeps the summary's
 * claim and the created record the same fact.
 */
export const create = async (values: WizardValues): Promise<AssetClass[]> => {
  const tagIds = await ensureTagIds(values.tags)
  const accountId = await ensureOwnerAccount(values)

  const loan = await createHolding({
    accountId,
    transactionType: TRANSACTION_TYPE.ADD_LIABILITY,
    name: values.assetName,
    type: values.assetType,
    currency: values.currency,
    description: values.description,
    amount: values.amount,
    date: values.date,
    tagIds,
  })

  return [loan]
}
